import { type PropsWithChildren } from "react";

export const Footer = ({ children }: Readonly<PropsWithChildren>) => (
  <footer data-testid="circle-ai-shell-panel-footer" className="shrink-0">
    {children}
  </footer>
);

Footer.displayName = "CircleAIAppShell.Layout.Panel.Footer";
